import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HrDashboardService {

  private routePrefix = '/api/hrDashboard';
  constructor(private http: HttpClient) { }

  getQueueReportByHr(data: any): Observable<any> {
    return this.http.post(this.routePrefix + '/getQueueReportByHr', data);
  }

  getQueueReportByGroup(data: any): Observable<any> {
    return this.http.post(this.routePrefix + '/getQueueReportByGroup', data);
  }

  getDetailedReportByHr(data: any): Observable<any> {
    return this.http.post(this.routePrefix + '/getDetailedReportByHr', data);
  }

  getLastAnniversaryByPolicy(groupPolicyId: number): Observable<any> {
    return this.http.get(this.routePrefix + '/getLastAnniversaryByPolicyId/' + groupPolicyId);
  }

  getGroupPolicyByHrUser(): Observable<any> {
    return this.http.get(this.routePrefix + '/getGroupPolicyByHrUser');
  }

  getReport(groupPolicyId: number, anniversaryId: number, claimTypePrefixId: number): Observable<any> {
    return this.http.get(this.routePrefix + '/get-hr-dashboard-data/' + groupPolicyId + '/' + anniversaryId + '/' + claimTypePrefixId)
  }

  getLastTwoAnniversariesByGroupPolicy(groupPolicyId: number): Observable<any> {
    return this.http.get(this.routePrefix + "/getLastTwoAnniversariesByGroupPolicy/" + groupPolicyId);
  }

  generateReport(payload: any): Observable<any> {
    return this.http.post(this.routePrefix + '/generateClaimsReport', payload);
  }

  sendEmailForAllClaimReport(payload: any): Observable<any> {
    return this.http.post(this.routePrefix + '/send-all-claim-report-email', payload);
  }
}
